import React from "react";
import { Pause, PlayArrow } from "@material-ui/icons";
import { Box, CircularProgress, IconButton } from "@material-ui/core";
export var TrackPlayerButton = function (_a) {
    var onPause = _a.onPause, onPlay = _a.onPlay, isPlaying = _a.isPlaying, isLoading = _a.isLoading;
    var Icon = isPlaying ? Pause : PlayArrow;
    var onClick = function () { return (isPlaying ? onPause() : onPlay()); };
    if (isLoading) {
        return (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "center", width: "100%" },
            React.createElement(IconButton, { size: "small", onClick: onPause },
                React.createElement(CircularProgress, { size: 15 }))));
    }
    return (React.createElement(IconButton, { size: "small", onClick: onClick },
        React.createElement(Icon, null)));
};
